module.exports = __webpack_public_path__ + "live-share-guest-yellow-d7c73d40.png";